import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export abstract class AbstractService {
    path !: string;

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        })
    };

    get baseUrl(): string {
        if (window.location.href.includes('upper.health') || window.location.href.toLowerCase().includes('uppercustomerportal.z13.web.core.windows.net')) {
            return 'https://upper-api.azurewebsites.net';
        } else if (window.location.href.includes('localhost')) {
            return 'https://localhost:5001';
        }
        return 'https://upper-qa-api.azurewebsites.net';
    }

    constructor(
        public http: HttpClient,
    ) {}

    post(pathSegments: string[], body: any): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);

        return this.http.post<any>(
            `${this.baseUrl}/${this.path}${pathSegmentString}`,
            JSON.stringify(body),
            this.httpOptions,
        );
    }

    put(pathSegments: string[], body: any): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);

        return this.http.put<any>(
            `${this.baseUrl}/${this.path}${pathSegmentString}`,
            JSON.stringify(body),
            this.httpOptions,
        );
    }

    getAll(pathSegments: string[], queryParameters: Map<string, any>): Observable<any[]> {
        const pathSegmentString = this._buildPathSegments(pathSegments);
        const queryParameterString = this._buildQueryParameters(queryParameters);

        return this.http.get<any[]>(
            `${this.baseUrl}/${this.path}${pathSegmentString}${queryParameterString}`,
            this.httpOptions,
        );
    }

    get(pathSegments: string[], queryParameters: Map<string, any>): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);
        const queryParameterString = this._buildQueryParameters(queryParameters);

        return this.http.get<any>(
            `${this.baseUrl}/${this.path}${pathSegmentString}${queryParameterString}`,
            this.httpOptions,
        );
    }

    delete(applicationServiceTypeId: string): Observable<any> {
        return this.http.delete<any>(
            `${this.baseUrl}/${this.path}/${applicationServiceTypeId}`,
            this.httpOptions,
        );
    }

    public _buildPathSegments(pathSegments: string[]): string {
        return pathSegments != null && pathSegments.length > 0 ? `/${pathSegments.join('/')}` : '';
    }

    public _buildQueryParameters(queryParameters: Map<string, any>): string {
        return queryParameters != null && queryParameters.size > 0
            ? `?${Array.from(queryParameters.keys()).map(key => key + '=' + queryParameters.get(key)).join('&')}`
            : '';
    }
}
